<template>
  <div class="credit-card" :class="{ 'active': selected }">

    <!-- General card -->
    <div class="credit-card-selected" v-if="selected">
      <span class="credit-card-selected-text"> {{ $t('Selected') }} </span>
    </div>
    <!---->

    <!-- Card naming -->
    <div class="credit-card-naming" :class="{ 'general': selected }">
      <img src="/assets/personal-details.svg" class="credit-card-naming-photo" alt="user-naming">
      <span class="credit-card-naming-title"> {{ card.details.card_alias }} </span>
    </div>
    <!---->

    <!-- Card code -->
    <div class="credit-card-code">
      <span class="credit-card-code-text"> {{ card.details.mask }} </span>
    </div>
    <!---->

    <!-- Card date -->
    <div class="credit-card-date" :class="{ 'general': selected }">
      <span class="credit-card-date-text"> {{ $t('Date') }}: </span>
      <span class="credit-card-date-text active" v-if="card.is_active"> {{ $t('Active') }} </span>
      <span class="credit-card-date-text active" v-else> {{ $t('Not active') }} </span>
    </div>
    <!---->

    <!-- Card actions -->
    <div class="credit-card-actions" :class="{ 'general': selected }">
      <button class="credit-card-actions-btn no-underline" v-if="!selected" @click="select"> {{ $t('Select') }} </button>
      <button class="credit-card-actions-btn no-underline" @click="removeCard"> {{ $t('Remove') }} </button>
    </div>
    <!---->

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CreditCard',
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      customerToken: 'user/getUserToken',
      getPhoneNumber: 'user/getPhoneNumber'
    }),
    getCustomerId () {
      return this.$store.state.user.current.id
    },
    selected () {
      return this.card.is_default
    }
  },
  methods: {
    ...mapActions({
      selectCard: 'ipay-payment-user/selectCard',
      deleteCard: 'ipay-payment-user/deleteCard'
    }),
    async select () {
      await this.selectCard({ token: this.customerToken, method_id: this.card.id })
        .then(() => this.$bus.$emit('ipay-selected-card', this.card.details.card_alias))
    },
    removeCard () {
      this.deleteCard({
        token: this.customerToken,
        cardName: this.card.name,
        customerId: this.getCustomerId,
        phoneNumber: this.getPhoneNumber(true),
        methodId: this.card.id
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .credit-card {
    width: calc(100% / 3 - 56px);

    padding: 20px;
    margin: 0 20px 20px 0;

    position: relative;

    display: flex;
    flex-direction: column;

    border: 1px solid #dedad7;
    border-radius: 5px;

    @media only screen and (max-width: 991px) {
      width: 100%;
      margin: 0 0 20px 0;
    }

    &.active {
      border-color: #11bb2e;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    &-selected {
      width: 120px;
      height: 20px;

      padding: 2px 0;

      position: absolute;
      top: 0;
      left: 0;

      background: #11bb2e;
      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;
      text-align: center;

      &-text {
        color: #fff;
        font-size: 14px;
      }
    }

    &-naming {
      padding-bottom: 8px;

      display: flex;
      justify-content: flex-start;
      align-items: center;

      &.general {
        padding-top: 12px;
      }

      &-photo {
        width: 22px;
        height: 22px;

        margin-right: 10px;
      }

      &-title {
        color: #111;
        font-size: 14px;
      }
    }

    &-code {
      padding-bottom: 8px;

      display: flex;
      justify-content: flex-start;
      align-items: center;

      &-text {
        color: #111;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 5px;

        @media only screen and (max-width: 1200px) {
          letter-spacing: 2px;
        }

        @media only screen and (max-width: 991px) {
          letter-spacing: 5px;
        }

        @media only screen and (max-width: 324px) {
          letter-spacing: 2px;
        }
      }
    }

    &-date {
      padding-bottom: 20px;

      display: flex;
      justify-content: flex-start;
      align-items: center;

      &.general {
        padding-bottom: 8px;
      }

      &-text {
        color: #4a4a4a;
        font-size: 14px;

        &.active {
          margin-left: 5px;

          color: #111;
          font-weight: 700;
        }
      }
    }

    &-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.general {
        justify-content: flex-end;
      }

      &-btn {
        padding: 0;

        color: #11bb2e;
        font-size: 14px;

        background: none;
        border: none;
        outline: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
